import { render, staticRenderFns } from "./backQrcode.vue?vue&type=template&id=00736e04&scoped=true&"
import script from "./backQrcode.vue?vue&type=script&lang=js&"
export * from "./backQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00736e04",
  null
  
)

export default component.exports